"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-VectorInput',
    inputs: 'c__VectorInput__inputs',
    error: 'c-VectorInput__error',
    leftInput: 'c-VectorInput__leftInput',
    rightInput: 'c-VectorInput__rightInput',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'block'
    },
    _a[exports.CSS.inputs] = (_b = {
            flex: 1,
            display: 'flex',
            'justify-content': 'space-between'
        },
        _b["& .".concat(exports.CSS.leftInput)] = {
            width: '60%'
        },
        _b["& .".concat(exports.CSS.rightInput)] = {
            width: '40%'
        },
        _b),
    _a[exports.CSS.error] = {
        visibility: 'visible',
        position: 'relative'
    },
    _a);
//# sourceMappingURL=vector.input.style.js.map